import { render } from "./RoleAdd.vue?vue&type=template&id=7ae3b156"
import script from "./RoleAdd.vue?vue&type=script&lang=js"
export * from "./RoleAdd.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__